export default __webpack_public_path__ + "static/media/artwork-card-3.b8c4823e.png";